import React from "react";
import { parseGameName } from "../../utils/utils";

const GameNameParser = ({ game_name, additionalClasses1, isProduct }) => {

  return <span key={game_name} className={additionalClasses1}>
    { parseGameName(game_name, isProduct) }
  </span>

};

export default GameNameParser;